import * as ES from  './es';
import * as EN from  './en';
export default {
    ES,
    EN
}